import React, { useEffect } from 'react';
import { Field } from 'redux-form';
import { useHistory } from 'react-router-dom';

import {
  FormWrapper,
  ButtonsWrapper,
  Error,
  FieldState
} from './styled';

import { normalizeText } from '@app/src/utils/normalizers';
import { FieldGroup } from '@app/src/components/Field';
import { Button } from '@app/src/components/Button';
import { required, email } from '@app/src/utils/validations';
import { RenderInput } from '@app/src/views/CipGeneration/generateForm/components/RenderInput';
import { RenderSelect } from '@app/src/views/CipGeneration/generateForm/components/RenderSelect';
import { ModalContainer } from './../Modal';

const roles = [
  {
    value: '0',
    label: 'Operador'
  },
  {
    value: '1',
    label: 'Administrador'
  }
];

const states = [
  {
    value: '0',
    label: 'Inactivo'
  },
  {
    value: '1',
    label: 'Activo'
  }
];

export const Form: React.FC<any> = ({
  handleSubmit,
  errorMessage,
  isFetching,
  handlefetchUserValues,
  message,
  reset,
  sessionRol,
  idUser
}) => {

  const history = useHistory();
  const handleClick = () => {
    history.push('/usuarios');
  }

  useEffect(() => {
    if (!idUser) {
      history.push('/usuarios');
      return;
    }
    handlefetchUserValues();
  }, []);

  return(
    <FormWrapper onSubmit={handleSubmit}>
      <Error>{errorMessage}</Error>
      <FieldGroup>
        <Field
          name="name"
          type="text"
          maxLength="50"
          label="Nombre (*)"
          portionWidth={1/2}
          component={RenderInput}
          validate={[required]}
          normalize={normalizeText}
          disabled
        />
        <Field
          name="lastName"
          type="text"
          maxLength="80"
          label="Apellidos (*)"
          portionWidth={1/2}
          component={RenderInput}
          validate={[required]}
          normalize={normalizeText}
          disabled
        />
      </FieldGroup>
      <FieldGroup>
        <Field
          name="email"
          type="text"
          maxLength="100"
          label="Email (*)"
          portionWidth={1/2}
          component={RenderInput}
          validate={[required, email]}
          disabled
        />
        <Field
          name="isAdmin"
          label="Rol"
          portionWidth={1/2}
          component={RenderSelect}
          options={roles}
        />
      </FieldGroup>
      <FieldState>
        <Field
          name="state"
          label="Estado"
          portionWidth={1/2}
          component={RenderSelect}
          options={states}
        />
      </FieldState>
      <ButtonsWrapper>
        <Button type="button" onClick={() => handleClick()} >Volver</Button>
        <Button primary type="submit" loading={isFetching}>Actualizar</Button>
      </ButtonsWrapper>
      <ModalContainer data-test="modal" message={message} reset={reset} sessionRol={sessionRol} />
    </FormWrapper>
  );
};
